import { Navigate } from "react-router-dom";

/** OTP is handled on the login page — keep route for old links/bookmarks. */
function OTP() {
  return <Navigate to="/Login" replace />;
}

export default OTP;
